import {
  ONBOARDING_CHECKLIST_PILL_BRAND,
  ONBOARDING_CHECKLIST_PILL_LABEL
} from "../constants";
import { DragHandle } from "../useDraggable";

const RING_SIZE = 24;
const RING_STROKE = 2.8;
const RING_RADIUS = (RING_SIZE - RING_STROKE) / 2;
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;

const ProgressRing = ({ progress }: { progress: number }) => (
  <svg
    className="shrink-0 -rotate-90"
    width={RING_SIZE}
    height={RING_SIZE}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <circle
      className="stroke-[#ffffff36]"
      cx="12"
      cy="12"
      r={RING_RADIUS}
      strokeWidth={RING_STROKE}
    />
    <circle
      className="stroke-primary-500"
      cx="12"
      cy="12"
      r={RING_RADIUS}
      strokeWidth={RING_STROKE}
      strokeLinecap="round"
      strokeDasharray={RING_CIRCUMFERENCE}
      strokeDashoffset={RING_CIRCUMFERENCE * (1 - progress / 100)}
    />
  </svg>
);

export const CollapsedPill = ({
  completedCount,
  totalCount,
  progress,
  onExpand,
  drag
}: {
  completedCount: number;
  totalCount: number;
  progress: number;
  onExpand: () => void;
  drag: DragHandle;
}) => {
  const { containerRef, dragStyle, handleProps, wasDragged } = drag;

  return (
    <button
      ref={containerRef}
      type="button"
      onClick={() => {
        if (wasDragged()) return;
        onExpand();
      }}
      {...handleProps}
      style={{ ...dragStyle, ...handleProps.style }}
      className="fixed bottom-4 left-4 z-[12] flex h-12 cursor-grab items-center gap-2 overflow-hidden rounded-full border border-alpha-100 bg-content-1000 px-4 shadow-xl transition-colors hover:bg-content-900 active:cursor-grabbing md:bottom-6 md:left-[104px]"
    >
      <ProgressRing progress={progress} />
      <span className="text-sm font-bold text-content-200">
        {ONBOARDING_CHECKLIST_PILL_BRAND}
      </span>
      <span className="text-sm font-bold text-content-1000-inverted">
        {ONBOARDING_CHECKLIST_PILL_LABEL} {completedCount}/{totalCount}
      </span>
    </button>
  );
};
